import axios from 'axios';
import { COTIZACIONES } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const listarCotizaciones = (filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: filtros.id_proyecto ?? null,
        status: filtros.status ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/listar`, body, config);

        await dispatch({
            type: COTIZACIONES.LISTAR,
            payload: res.data?.cotizaciones || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: COTIZACIONES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar cotizaciones', 'danger'));
        return false;
    }
};

export const filtrarCotizaciones = (texto = '') => dispatch => {
    dispatch({
        type: COTIZACIONES.FILTRAR,
        payload: texto
    });
};

export const limpiarCotizaciones = () => dispatch => {
    dispatch({ type: COTIZACIONES.LIMPIAR });
};

export const obtenerCotizacion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch({ type: COTIZACIONES.DETALLE_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/detalles`, body, config);

        await dispatch({
            type: COTIZACIONES.DETALLE,
            payload: res.data?.cotizacion || null
        });

        await dispatch(changeLoader(false));
        return res.data?.cotizacion || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: COTIZACIONES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar la cotización', 'danger'));
        return null;
    }
};

export const limpiarDetalleCotizacion = () => dispatch => {
    dispatch({ type: COTIZACIONES.LIMPIAR_DETALLE });
};

export const crearCotizacion = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: data.id_proyecto || '',
        fecha: data.fecha || null,
        nombre: data.nombre || null,
        descripcion: data.descripcion || null,
        total: data.total ?? 0,
        productos: Array.isArray(data.productos) ? data.productos : [],
        conceptos: Array.isArray(data.conceptos) ? data.conceptos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/crear`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear la cotización', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Cotización creada correctamente', 'success'));

        return res.data?.cotizacion || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: COTIZACIONES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear la cotización', 'danger'));
        return null;
    }
};

export const editarCotizacion = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        nombre: data.nombre || null,
        descripcion: data.descripcion || null,
        total: data.total ?? 0,
        productos: Array.isArray(data.productos) ? data.productos : [],
        conceptos: Array.isArray(data.conceptos) ? data.conceptos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/editar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar la cotización', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Cotización editada correctamente', 'success'));

        return res.data?.cotizacion || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: COTIZACIONES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar la cotización', 'danger'));
        return null;
    }
};

export const crearVersionCotizacion = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        folio_base: data.folio_base || '',
        fecha: data.fecha || null,
        nombre: data.nombre || null,
        descripcion: data.descripcion || null,
        total: data.total ?? 0,
        productos: Array.isArray(data.productos) ? data.productos : [],
        conceptos: Array.isArray(data.conceptos) ? data.conceptos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/crear_version`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear la nueva versión', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Versión creada correctamente', 'success'));

        return res.data?.cotizacion || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: COTIZACIONES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear la nueva versión', 'danger'));
        return null;
    }
};

export const eliminarCotizacion = (id, id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/eliminar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar la cotización', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Cotización eliminada correctamente', 'success'));

        await dispatch(listarCotizaciones({ id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: COTIZACIONES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar la cotización', 'danger'));
        return false;
    }
};

/* Lee el mensaje de error de una respuesta con responseType 'blob': cuando el backend responde
   400/500, el cuerpo (JSON con { msg, success }) llega como Blob y no como objeto ya parseado. */
const extraerMensajeErrorBlob = async (error) => {
    try {
        const blob = error?.response?.data;
        if (blob instanceof Blob) {
            const texto = await blob.text();
            const json = JSON.parse(texto);
            return json?.msg || null;
        }
    } catch (err) {
        // El cuerpo no era JSON (ej. sí es un PDF de error genérico del servidor); se ignora.
    }
    return null;
};

/* Pide el PDF de la cotización al backend (endpoint aún por implementarse ahí) y lo abre
   en una pestaña nueva usando el visor de PDF nativo del navegador. */
export const generarPdfCotizacion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cotizaciones/pdf`, body, config);
        await dispatch(changeLoader(false));

        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        const msg = await extraerMensajeErrorBlob(error);
        dispatch(setAlert(msg || 'Error al generar el PDF de la cotización', 'danger'));
        return false;
    }
};
